module.exports = "../images/northern-pike-v2.jpg?v=9e41877";